<template>
  <button
    type="button"
    class="confirm-button"
    @click="$emit('click', $event)"
    :disabled="buttonDisabled"
  >
    {{ buttonText }}
  </button>
</template>

<script>
export default {
  name: "CertConfirmButton",
  props: {
    buttonText: String,
    buttonDisabled: {
      type: Boolean,
      default: false,
    },
  },
};
</script>

<style lang="scss" scoped>
.mtm {
  button {
    border: 1px solid $exMtm;
    border-radius: $exMtmBtnBorderRadius;
    background-color: $exMtm;
    &:not(:disabled):hover,
    &:not(:disabled):focus {
      border-color: $exMtmActive;
      background-color: $exMtmActive;
    }
  }
}
button {
  padding: 16px 26px;
  color: #fff;
  border: 1px solid $exBlue;
  border-radius: $buttonBorderRadius;
  background-color: $exBlue;
  @include fontSize(14px);
  font-weight: bold;
  line-height: 17px;
  cursor: pointer;
  min-width: $buttonMinWidth;

  &:disabled {
    cursor: default;
    background-color: $bgLightGray;
    border-color: $bgLightGray;
    color: $mediumGray;
  }
  &:not(:disabled):hover,
  &:not(:disabled):focus {
    border-color: $exBlueActive;
    background-color: $exBlueActive;
  }
}
</style>
